import React, { useEffect } from 'react'
import DynamicContentRowInputField from 'domains/announcements/components/dynamic-content-row-input-field'
import { Label } from 'reactstrap'

import PropTypes from 'prop-types'

const propTypes = {
  inputTitle              : PropTypes.string,
  dynamicContents         : PropTypes.array,
  receiver                : PropTypes.string,
  setFieldValue           : PropTypes.func,
  onChangeDynamicContents : PropTypes.func,
  csvColumns              : PropTypes.array,
  fieldName               : PropTypes.string
}

const DynamicContentFormSection = ({
  inputTitle,
  dynamicContents,
  receiver,
  setFieldValue,
  onChangeDynamicContents,
  csvColumns,
  fieldName
}) => {

  useEffect(() => {
    onChangeDynamicContents([ ...dynamicContents ])
  }, [ dynamicContents ])

  const handleUpdateAttributeAfterChange = (event, index) => {
    const fieldValue = event.target.value

    setFieldValue(`${fieldName}[${index}].attribute`, fieldValue)
    if (fieldValue === 'manual') {
      setFieldValue(`${fieldName}[${index}].resource`, 'manual')
      setFieldValue(`${fieldName}[${index}].value`, '')
    } else if (csvColumns.includes(fieldValue)){
      setFieldValue(`${fieldName}[${index}].resource`, 'csv')
      setFieldValue(`${fieldName}[${index}].value`, fieldValue)
    } else {
      setFieldValue(`${fieldName}[${index}].resource`, 'receiver')
      setFieldValue(`${fieldName}[${index}].value`, fieldValue)
    }
  }
  return (
    <>
      {
        dynamicContents.map((dynamicContent, index) => {

          if (receiver) {
            return (
              <div  key={ `dynamic-field-${ index + 1}` }>
                <Label className='text-gray-light text-capitalize font-weight-bolder text-nowrap'>
                  { inputTitle }
                </Label>
                <DynamicContentRowInputField
                  index={ index }
                  onUpdateAttributeAfterChange={ (event, index) => handleUpdateAttributeAfterChange(event, index) }
                  receiver={ receiver }
                  currentDynamicContent={ dynamicContent }
                  csvColumns={ csvColumns }
                  fieldName={ fieldName }
                />
              </div>
            )
          }
        })
      }
    </>
  )
}

DynamicContentFormSection.propTypes = propTypes

export default DynamicContentFormSection
